import { render, staticRenderFns } from "./IdiomModal.vue?vue&type=template&id=0c0ac260&"
import script from "./IdiomModal.vue?vue&type=script&lang=js&"
export * from "./IdiomModal.vue?vue&type=script&lang=js&"
import style0 from "./IdiomModal.vue?vue&type=style&index=0&id=0c0ac260&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports